import { CALENDAR_CONFIG } from "@/config/rooms";

export function getEventPosition(
  start: Date,
  end: Date
): { top: number; height: number } {
  const startHour = start.getHours() + start.getMinutes() / 60;
  const endHour = end.getHours() + end.getMinutes() / 60;

  const top =
    (startHour - CALENDAR_CONFIG.startHour) * CALENDAR_CONFIG.hourHeight;
  const height = (endHour - startHour) * CALENDAR_CONFIG.hourHeight;

  return { top: Math.max(0, top), height: Math.max(height, 20) }; // Min height 20px
}

export function getCurrentTimePosition(time: Date): number {
  const hour =
    time.getHours() + time.getMinutes() / 60 + time.getSeconds() / 3600;
  return (hour - CALENDAR_CONFIG.startHour) * CALENDAR_CONFIG.hourHeight;
}

export function formatTime(date: Date): string {
  return date.toLocaleTimeString("ko-KR", {
    hour: "numeric",
    minute: "2-digit",
    hour12: false,
  });
}

export function formatTimeShort(date: Date): string {
  return date.toLocaleTimeString("ko-KR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function getHourLabels(): { hour: number; label: string }[] {
  const labels: { hour: number; label: string }[] = [];
  for (let h = CALENDAR_CONFIG.startHour; h <= CALENDAR_CONFIG.endHour; h++) {
    labels.push({
      hour: h,
      label: `${h.toString().padStart(2, "0")}:00`,
    });
  }
  return labels;
}

export function getTotalGridHeight(): number {
  const totalHours = CALENDAR_CONFIG.endHour - CALENDAR_CONFIG.startHour + 1;
  return totalHours * CALENDAR_CONFIG.hourHeight;
}

export function isWithinDisplayHours(time: Date): boolean {
  const hour = time.getHours();
  return hour >= CALENDAR_CONFIG.startHour && hour <= CALENDAR_CONFIG.endHour;
}
